// Internal imports
import { Wrapper } from "./skils-component.styles";
import { FormattedMessage } from "react-intl";
import { motion } from "framer-motion";

// internal imports
import { skillsCategory } from "../../utils/data/data.utils";
import SkillsCategory from "../skills-category/skills-category.component";
import sectionWrapper from "../../hoc/sction-wrapper.component";
import { zoomIn } from "../../utils/motion/motion.utils";

const Skill = () => {
  return (
    <Wrapper className="section">
      <motion.h3 variants={zoomIn()}>
        <FormattedMessage
          id="technical.skills"
          defaultMessage="Technical Skills"
        />
      </motion.h3>
      <div className="skills-container">
        {skillsCategory?.map((category, index) => (
          <SkillsCategory
            key={`key-${category.id}-${index}`}
            index={index}
            {...category}
          />
        ))}
      </div>
    </Wrapper>
  );
};

export default sectionWrapper(Skill);
